module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.605 15.593l-8.448-3.618 2.724-5.397c.258-.512.053-.718-.459-.459l-5.396 2.724-3.62-8.45c-.228-.524-.59-.524-.816 0l-3.618 8.45-5.397-2.725c-.512-.26-.715-.053-.46.459l2.725 5.397-8.446 3.62c-.526.226-.526.59 0 .816l8.448 3.618-2.727 5.397c-.256.508-.052.715.46.459l5.397-2.724 3.618 8.446c.226.528.588.528.816 0l3.62-8.446 5.396 2.724c.512.258.715.05.459-.459l-2.724-5.397 8.448-3.618c.524-.226.524-.592 0-.816zM16 19.554a3.557 3.557 0 1 1 .001-7.113A3.557 3.557 0 0 1 16 19.554z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/explore-1.js
// module id = 1130
// module chunks = 14